import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { BannerService } from '../../services/banner/banner.service';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-ltms-banner',
    templateUrl: './ltms-banner.component.html',
    styleUrls: ['./ltms-banner.component.scss'],
    imports: [NgIf, NgClass]
})
export class LtmsBannerComponent implements OnInit {
  message: string = '';
  bannerType: string = ''
  componentName: string = ''
  event: any = null

  constructor(private _bannerService: BannerService) { }
  ngOnInit(): void {
    this._bannerService.error$.subscribe((props: any) => {
      this.message = (props.message) ? props.message : ''
      this.bannerType = (props.bannerType) ? props.bannerType : 'error'
      this.componentName = (props.component) ? props.component : ''
      this.event = (props.callback) ? props.callback : null
    });
  }
  //componetName - only in this case
  refresh(): void {
    if (this.event) {
      // Refresh the page or the specific component
      this.event(this.componentName)
      this._bannerService.clearError();
    }
  }

  handleButtonClick(): void {
    if (this.bannerType === 'error') {
      this.refresh();
      //todo - need to relaod ,a specific component
    } else if (this.bannerType === 'warning') {
      this.refresh();
    }
  }
  
  handleOk(): void {
    this.refresh(); 
  }
  
  cancelAction(): void {
    this._bannerService.clearError();
  }
  
  // Dynamically change button text based on bannerType
  getButtonText(): string {
    if (this.bannerType === 'error') {
      return 'Reload';
    } else if (this.bannerType === 'warning') {
      return 'Refresh';
    } else {
      // todo if any other button required in future
      return 'other';
    }
  }
}